<template>
  <div>
    <div class="web-body">
      <div class="about">
        <div class="row clearfix product-box">
          <p-e-n v-if="isShowEN"/>
          <p-c-n v-else/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import cn from './privacy/cn'
import en from './privacy/en'

export default {
  name: "privacy",
  components: {
    pCN: cn,
    pEN: en
  },
  data() {
    return {
      isShowEN: false
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  created() {
    let userLanguage = navigator.language || navigator.userLanguage;
    userLanguage = userLanguage.toLowerCase()
    if (!(userLanguage.indexOf('zh') !== -1 || userLanguage.indexOf('cn') !== -1)) {
      this.isShowEN = true
    }
  }
}
</script>

<style scoped>
h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {
  margin: 0;
}

body {
  padding: 20px 20px 20px 20px;
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;

}

h1 {
  text-align: center;
  font-size: 32px;
  line-height: 48px;
}

h2 {
  font-weight: bold;
  font-size: 28px;
}

b {
  font-weight: bold;
}

.web-body {
  width: 100vw;
  overflow-x: auto;
}

table {
  text-align: left;
  font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
  /*font-size: 1.2rem;*/
  /*line-height: 2.2rem;;*/
  border: 1px solid #909399;
  border-collapse: collapse;
}

tr th {
  font-weight: bold;
  background-color: #F7F8FA;
  /*padding: 6px;*/
}

tr td {
  padding: 6px;
}

a {
  color: #0000ff;
}

a2 {
  display: block;
  width: 160px;
  word-wrap: break-word;
}
</style>



// WEBPACK FOOTER //
// src/components/privacy.vue